import { SET_SALT_MODE } from './types';

export const setSaltMode = mode => ({ type: SET_SALT_MODE, mode });
